import React, { createContext, useContext, useState, ReactNode } from 'react';

interface LanguageToggleContextType {
    showEnglish: boolean;
    setShowEnglish: (show: boolean) => void;
    toggleLanguage: () => void;
}

const LanguageToggleContext = createContext<LanguageToggleContextType | undefined>(undefined);

export const useLanguageToggle = () => {
    const context = useContext(LanguageToggleContext);
    if (context === undefined) {
        throw new Error('useLanguageToggle must be used within a LanguageToggleProvider');
    }
    return context;
};

interface LanguageToggleProviderProps {
    children: ReactNode;
}

export const LanguageToggleProvider: React.FC<LanguageToggleProviderProps> = ({ children }) => {
    const [showEnglish, setShowEnglish] = useState(true); // Default to English

    const toggleLanguage = () => {
        setShowEnglish(!showEnglish);
    };

    return (
        <LanguageToggleContext.Provider value={{ showEnglish, setShowEnglish, toggleLanguage }}>
            {children}
        </LanguageToggleContext.Provider>
    );
}; 